import styled from "styled-components";

import { background } from "bulma/color";

export default styled.footer`
    background-color: ${background};
    padding: 3rem 1.5rem 6rem;
`;



// WEBPACK FOOTER //
// ./bulma/layout/Footer.tsx